import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
export const timeRangeConstants = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  LAST_WEEK: 'last_7_days',
  LAST_MONTH: 'last_month',
  MONTH_TO_DATE: 'month_to_date',
  LAST_7_DAYS: 'previous_7_days',
  LAST_30_DAYS: 'last_30_days',
  YEAR_TO_DATE: 'year_to_date',
  CUSTOM: 'custom',
};

export const useTimeRangesOptions = () => {
  const { t, i18n } = useTranslation();
  const timeRangesOptions = useMemo(
    () => [
      {
        value: timeRangeConstants.TODAY,
        label: t('Today'),
      },
      {
        value: timeRangeConstants.YESTERDAY,
        label: t('Yesterday'),
      },
      {
        value: timeRangeConstants.LAST_WEEK,
        label: t('Last Week'),
      },
      {
        value: timeRangeConstants.LAST_MONTH,
        label: t('Last Month'),
      },
      {
        value: timeRangeConstants.MONTH_TO_DATE,
        label: t('Month to Date'),
      },
      {
        value: timeRangeConstants.LAST_7_DAYS,
        label: t('Last 7 days'),
      },
      {
        value: timeRangeConstants.LAST_30_DAYS,
        label: t('Last 30 days'),
      },
      {
        value: timeRangeConstants.YEAR_TO_DATE,
        label: t('Year to Date'),
      },
      {
        value: timeRangeConstants.CUSTOM,
        label: t('Custom...'),
      },
    ],
    [i18n.language]
  );

  const [timeRanges, setTimeRanges] = useState(timeRangesOptions);
  useEffect(() => {
    setTimeRanges(timeRangesOptions);
  }, [i18n.language]);

  return { timeRangesOptions, timeRanges, setTimeRanges, i18n };
};
